import { Grid, List, withStyles } from "@material-ui/core";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { useAppDispatch, useAppSelector } from "../app/appHooks";
import MuiListItem from "@material-ui/core/ListItem";
import { setSelectedUnit } from "./reportsSlice";
import { getUnitTitle } from "../dashboard/CommunityUnit";
import { useTranslation } from "react-i18next";
import { minToolbarHeight } from "../app/App";

const useStyles = makeStyles<Theme, Boolean>((theme: Theme) =>
  createStyles({
    unitListContainer: {
      width: "100%",
      overflowY: "auto",
      height: (showBanner) =>
        `calc(100vh - ${minToolbarHeight(showBanner, theme)})`,
      paddingTop: "0px",
      borderRight: "1px solid #ccc",
    },
    itemLabelContainer: {
      display: "flex",
      width: "100%",
      alignItems: "center",
      justifyContent: "space-between",
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(0),
    },
    secondaryTextContainer: {
      padding: theme.spacing(0, 2),
      display: "flex",
      justifyContent: "flex-end",
      textAlign: "right",
    },
    loadFont: {
      position: "absolute",
      top: 0,
      right: "50%",
      zIndex: -1,
      height: "1px",
      width: "1px",
      visibility: "hidden",
      fontFamily: theme.typography.tertiaryFontFamily,
    },
    pageTitle: {
      display: "flex",
      alignItems: "center",
      paddingLeft: theme.spacing(3),
      borderBottom: "1px",
      height: "50px",
      backgroundColor: theme.palette.light.main,
      fontSize: "1.1rem",
    },
  })
);

const ListItem = withStyles(({ palette, spacing }) => ({
  root: {
    paddingBottom: spacing(1),
    paddingTop: spacing(1),
    borderRadius: "0px",
    "&$selected": {
      backgroundColor: `${palette.primary.main}4D !important `,
      fontWeight: "bold",
    },
    "&$selected:hover": {
      backgroundColor: palette.primary.main,
    },
    "&:hover": {
      backgroundColor: `${palette.primary.main}4D !important `,
    },
  },
  selected: {},
  divider: {},
}))(MuiListItem);

export function UnitList() {
  const showBanner = useAppSelector((state) => state.headerState.showBanner);

  const classes = useStyles(showBanner);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  /* Selectors */
  const units = useAppSelector((state) => state.reportsState.units);
  const selectedUnit = useAppSelector(
    (state) => state.reportsState.selectedUnit
  );

  const handleSelectUnit = (unitID: string) => {
    dispatch(setSelectedUnit(unitID));
  };

  return (
    <List aria-labelledby="unit-list" className={classes.unitListContainer}>
      <div className={classes.pageTitle}>{t("reports")}</div>
      {units?.map((unit) => {
        const listItemText = getUnitTitle(unit);
        return (
          <ListItem
            key={unit.id}
            button
            onClick={() => handleSelectUnit(unit.id)}
            selected={unit.id === selectedUnit}
            divider
            disableGutters
          >
            <Grid container className={classes.itemLabelContainer}>
              <Grid item xs={5}>
                {listItemText.unitTitle}
              </Grid>
              <Grid item xs={7}>
                <div className={classes.secondaryTextContainer}>
                  <span>{listItemText.unitSubtitle}</span>
                </div>
              </Grid>
            </Grid>
          </ListItem>
        );
      })}
      <span className={classes.loadFont}>|</span>
    </List>
  );
}
